import * as React from 'react';
import * as Yup from 'yup';

import { Formik, FormikActions, FormikProps } from 'formik';
import { processApiError, toFormGroupStyle } from 'common/utils/form';

import { Activity } from 'common/api/models/Activity';
import { ActivityApi } from 'common/api/resources/ActivityApi';
import { FormErrorFeedback } from 'common/components/form/FormErrorFeedback';
import { FormGroup } from 'reactstrap';
import { FormInput } from 'common/components/form/FormInput';

interface ActivityFeedBadgeFormProps {
  entityId: string;
  entityType: string;
  onCancel: () => void;
  onSave: () => void;
}

interface BadgeFormValues {
  type: string;
  description: string;
  note: string;
}

export class ActivityFeedBadgeForm extends React.Component<ActivityFeedBadgeFormProps> {
  validationSchema = Yup.object().shape({
    type: Yup.string().required('Type is required.'),
    description: Yup.string().required('Description is required.'),
    note: Yup.string(),
  });

  getInitialValues = () => {
    const values: BadgeFormValues = { type: 'BADGE_MEETING', note: '', description: '' };
    return values;
  };

  handleSubmit = (values: BadgeFormValues, actions: FormikActions<BadgeFormValues>) => {
    ActivityApi.createActivity({
      entityId: this.props.entityId,
      entityType: this.props.entityType,
      type: Activity.Type[values.type],
      note: values.note,
      description: values.description,
    }).then(
      res => {
        this.props.onSave();
        actions.setSubmitting(false);
        actions.resetForm();
      },
      err => {
        processApiError(err, actions);
      }
    );
  };

  render() {
    return (
      <div className="card card-responsive">
        <div className="card-block">
          <Formik
            initialValues={this.getInitialValues()}
            validationSchema={this.validationSchema}
            onSubmit={this.handleSubmit}
            render={(form: FormikProps<BadgeFormValues>) => (
              <form onSubmit={form.handleSubmit}>
                <FormInput
                  tag="select"
                  id="type"
                  name="type"
                  label="Event Type"
                  value={form.values.type}
                  onChange={form.handleChange}
                >
                  <option value="BADGE_MEETING">In-Person Event</option>
                  <option value="BADGE_VIRTUAL">Virtual Event</option>
                </FormInput>
                <FormGroup color={toFormGroupStyle('description', form)}>
                  <textarea
                    name="description"
                    className="form-control"
                    placeholder="Add a description that will be visible to the member."
                    rows={1}
                    onChange={form.handleChange}
                    value={form.values.description}
                  />
                  <FormErrorFeedback form={form} field="description" />
                </FormGroup>
                <FormGroup color={toFormGroupStyle('note', form)}>
                  <textarea
                    name="note"
                    className="form-control"
                    placeholder="Add an optional note. Notes are strictly internal to NKBA staff."
                    rows={2}
                    onChange={form.handleChange}
                    value={form.values.note}
                  />
                  <FormErrorFeedback form={form} field="note" />
                </FormGroup>
                <div className="row">
                  <div className="col">
                    <a className="btn btn-sm btn-secondary" onClick={this.props.onCancel}>
                      Cancel
                    </a>{' '}
                    <button className="btn btn-sm btn-primary">Save</button>
                  </div>
                </div>
              </form>
            )}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/activity/ActivityFeedBadgeForm.tsx